<i18n src="./resources/locales.json"></i18n>
<template>
  <div>
    <div v-if="!email.attachmentsHaveValidSize" class="red--text d-flex align-center my-2">
      {{ $t('fileSizeError') }}
    </div>
    <div v-if="attachments.length > 0" class="d-flex flex-row flex-wrap">
      <EcsEmailAttachment
        v-for="(attachment, index) in attachments"
        :key="index"
        close
        :attachment-id="attachment.id"
        :file="attachment.file"
        :file-name="attachment.name"
        :content-type="attachment.contentType"
        :error="attachment.error"
        @attachmentClose="onAttachmentClose"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import EcsEmailAttachment from '@/components/ecs-email/ecs-email-attachment/EcsEmailAttachment';

export default {
  name: 'EcsEmailUploadAttachments',
  components: { EcsEmailAttachment },
  props: {
    email: {
      type: Object,
      required: true
    }
  },
  computed: {
    attachments() {
      return this.email.outgoingEmailData.attachments;
    }
  },
  mounted() {
    window.addEventListener('beforeunload', this.onRefreshRemoveAttachments);
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.onRefreshRemoveAttachments);
  },
  methods: {
    ...mapActions('INTERACTIONS/emails', ['removeOutgoingAttachment', 'clearAttachments', 'updateValidAttachments']),
    async onAttachmentClose(id) {
      await this.removeOutgoingAttachment({ interactionId: this.email.interactionId, id });
      this.updateValidAttachments(this.email.interactionId);
    },
    onRefreshRemoveAttachments(event) {
      if (!this.attachments.length) {
        return;
      }

      this.clearAttachments({ interactionId: this.email.interactionId });
    }
  }
};
</script>
<style scoped></style>
